enum RecognizePatientResultCode {
  PatientRecognized = 'patient_recognized',
  PatientNotRecognized = 'patient_not_recognized',
  PatientNotRecognizedButCanBeCreated = 'patient_not_recognized_but_can_be_created',
  PatientCreated = 'patient_created',
  Failed = 'failed'
}

export default RecognizePatientResultCode;
